import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-select__single-value" }
const _hoisted_2 = { class: "rules-selector-dropdown__options" }
const _hoisted_3 = {
  key: 0,
  class: "rules-selector-dropdown__divider"
}
const _hoisted_4 = ["disabled", "onClick"]

import { computed, nextTick, ref, type CSSProperties } from 'vue';
import AppResizableDropdown from '@/components/ui-kit/dropdown/AppResizableDropdown.vue';
import AppIcon from '@/components/ui-kit/icon/AppIcon.vue';
import type { SelectOption } from '@/components/ui-kit/select/AppSelect.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RulesSelectorDropdown',
  props: {
    modelValue: {},
    items: {},
    disabled: { type: Boolean, default: false },
    customTriggerStyle: { default: () => ({}) }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dropdownRef = ref<InstanceType<typeof AppResizableDropdown> | null>(null);

const selectedLabel = computed(() =>
  props.items.find((item) => item.id === props.modelValue)?.label ?? '',
);

function select(id: string | number) {
  if (props.disabled) return;
  emit('update:modelValue', id);
  nextTick(() => dropdownRef.value?.close());
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppResizableDropdown, {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    class: "rules-selector-dropdown",
    position: "bottom",
    "content-z-index": 10002,
    "fullscreen-on-mobile": false
  }, {
    activator: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["app-select__trigger", { 'app-select__trigger--disabled': _ctx.disabled }]),
        style: _normalizeStyle(_ctx.customTriggerStyle),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.disabled && $event.stopPropagation()))
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(selectedLabel.value), 1),
        _createVNode(AppIcon, {
          class: "app-select__arrow",
          name: "chevron-down",
          width: "16px",
          color: "#979797"
        })
      ], 6)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: String(item.id)
          }, [
            (index > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["rules-selector-dropdown__option", {
            'rules-selector-dropdown__option--selected': _ctx.modelValue === item.id,
            'rules-selector-dropdown__option--disabled': item.disabled,
          }]),
              disabled: item.disabled,
              onClick: _withModifiers(($event: any) => (select(item.id)), ["stop"])
            }, _toDisplayString(item.label), 11, _hoisted_4)
          ], 64))
        }), 128))
      ])
    ]),
    _: 1
  }, 512))
}
}

})